import React from 'react';
import { ChannelConnectionProps } from './ChannelConnection';
import { Skeleton } from '@mui/material';
import useChannelSetPoint from './hooks/useChannelSetPoint';
import { ChannelDetail } from './ChanelPanel';
import { getValueWithPreferredUnitAndDecimals } from '../../../../../redux/controlUnit/api/util/sensor/formatValues';
import usePreferredTemperatureUnit from '../../../../../redux/settings/hooks/usePreferredTemperatureUnit';

function ChannelSetPoint(props: ChannelConnectionProps) {
  const {
    name,
    loading,
    valueString: setPointValue,
    value: setPoint,
    unitString: setPointUnitValue,
    decimals: setPointDecimals,
  } = useChannelSetPoint(props);

  const { data: preferredTemperatureUnit } = usePreferredTemperatureUnit();
  const { value, unit } = getValueWithPreferredUnitAndDecimals(
    Number(setPoint ?? 0),
    setPointUnitValue,
    1,
    preferredTemperatureUnit
  );
  return (
    <>
      {loading && setPointValue == undefined ? (
        <Skeleton variant="text" width={'100%'} component={'span'} />
      ) : (
        <ChannelDetail title={name ?? ''} value={value} unit={unit} />
      )}
    </>
  );
}

export default ChannelSetPoint;
